module.exports = __webpack_public_path__ + "media/images/question-img-5f694944ab3cf7aa2497ffde41031640.png";